import React from "react";
import { styled } from "../../stitches.config";

const DotsHeader = () => (
    <Dots className="dots">
        <svg
            width="100"
            height="350"
            viewBox="0 0 104 363"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path d="M207.994 101.582C208.218 121.987 202.281 141.995 190.94 159.054C179.599 176.113 163.369 189.449 144.32 197.36C125.271 205.272 104.267 207.4 83.9874 203.473C63.7083 199.546 45.0735 189.743 30.4609 175.313C15.8483 160.884 5.92034 142.483 1.94372 122.458C-2.0329 102.433 0.122152 81.6922 8.13391 62.8819C16.1457 44.0716 29.6509 28.0446 46.9264 16.846C64.2018 5.64729 84.4643 -0.215365 105.128 0.0060478C132.199 0.66871 157.975 11.5831 177.122 30.4906C196.27 49.398 207.323 74.851 207.994 101.582ZM207.994 360.189C208.218 380.595 202.281 400.603 190.94 417.662C179.599 434.721 163.369 448.057 144.32 455.968C125.271 463.879 104.267 466.007 83.9874 462.081C63.7083 458.154 45.0735 448.35 30.4609 433.921C15.8483 419.491 5.92034 401.09 1.94372 381.065C-2.0329 361.041 0.122152 340.3 8.13391 321.49C16.1457 302.679 29.6509 286.652 46.9264 275.454C64.2018 264.255 84.4643 258.392 105.128 258.614C132.199 259.276 157.975 270.191 177.122 289.098C196.27 308.006 207.323 333.459 207.994 360.189Z" />
        </svg>
    </Dots>
);

const Dots = styled("div", {
    position: "absolute",
    right: "0",
    bottom: "0",
    height: "350px",
    width: "100px",
    display: "none",
    "@bp5": {
        /* nie 996px ponieważ zasłania treść przy tapecie */
        display: "block",
    },
    "svg": {
        fill: "$primary",
    },
});

export default DotsHeader;

